import axios from 'axios'
import serialize from 'form-serialize'
import Component from '../lib/Component'

export default class AjaxForm extends Component {
  constructor (elem, APP) {
    super(elem, APP)
    this.wrapper = this.elem.parentElement.parentElement
    this.submitBtn = this.elem.querySelector('.js--AjaxForm__submit')
    this.action = this.elem.getAttribute('action')
    this.nonceName = this.elem.getAttribute('data-nonce-name')
    this.nonceField = this.elem.querySelector('input[name="_wpnonce"]')
    this.nonce = window[this.nonceName.toUpperCase()]
  }

  submitForm (e) {
    if (this.elem.checkValidity()) {
      e.preventDefault()
      this.sendData()
      return false
    } else {
      return true
    }
  }

  sendData () {
    this.APP.events.publish('AjaxForm:sending')
    this.addClass('_form_sending', this.wrapper)
    let formData = serialize(this.elem)
    axios.post(this.action, formData)
      .then((response) => {
        this.events.publish('AjaxForm:success', response.data)
        this.showSuccess(response.data)
        this.removeClass('_form_sending', this.wrapper)
      })
      .catch((error) => {
        this.events.publish('AjaxForm:error', error)
        this.removeClass('_form_sending', this.wrapper)
      })
  }

  showSuccess (data) {
    let message = `<p>${data.success_message}</p>`
    this.addClass('_is_successful', this.wrapper)
    this.wrapper.innerHTML = `
      <div class="form-wrapper__success">
        ${message}
      </div>
    `
  }

  updateNonce () {
    if (this.nonce &&
      this.nonce !== this.nonceField.value) {
      this.nonceField.value = this.nonce
    }
  }

  init () {
    this.updateNonce()
    this.submitBtn.addEventListener('click', this.submitForm.bind(this))
    this.events.subscribe('AjaxForm:success', this.showSuccess.bind(this))
  }
}
